module.exports = __webpack_public_path__ + "img/face-kiss-closed-eyes.31b1d7e4.svg";